import i18n from '@/lang/i18n'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { PaginatorDatasource } from '@/shared/resources/datasources/paginator/paginator-datasource'
import { topographicCodesConfigurationServices } from '@/api/resources/configuration/samples/topography/TopographicCodesConfigurationServices'
import { initialCrudModelBaseState, CrudModelBase } from '@/shared/models/cruds.models'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'

export const columnsDefTopographicCodesGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.code'),
            field: 'code',
            width: 150,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.topography'),
            field: 'description',
            minWidth: 280,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 150,
            suppressSizeToFit: true
        }
    ]

export interface IContentTopographicCodesGrid {
    id?: number
    code: string
    description: string
    active: boolean
}
export const initialTopographicCodesModalState =
    (): IContentTopographicCodesGrid => ({
        id: undefined,
        code: '',
        description: '',
        active: false
    })

export type ITopographicCodesGridState = CrudModelBase<IContentTopographicCodesGrid>
export const initialTopographicCodesGridState =
    (): ITopographicCodesGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.global.samples.topography',
        columnsDef: columnsDefTopographicCodesGrid(),
        datasource: new PaginatorDatasource(topographicCodesConfigurationServices)
    })
